import { BaseLayerOptions } from './base-layer-options';

export class LineLayerOptions extends BaseLayerOptions {
    fallbackColor?: string;
    lineWidth: any = 1;
    dashed?: boolean;
    dashedWidth?: any;
    sort: any;

    color?: any;
    text?: boolean;
    textField?: any;

    border?: boolean;
    borderColor?: any;
    borderWidth?: any;
    borderOpacity?: any;
}
